import React from 'react';
import { GeneralFila } from '../../../Models/General';
import FilaCompra from './FilaCompra';
import { Link } from 'react-router-dom';
import { conCompra } from '../../../Models/Compra';
import CardBuscador from '../../../Utiles/Buscadores/Card';
import Avanzado, { AvanzadosProps } from '../../../Utiles/Componentes/Avanzado';
import { Producto } from '../../../Models/Productos';
import { ComprasContext } from '../../../Context/Compras';
import CompraExcel from './Excel';
import { Col } from 'react-bootstrap';
import { fechaToNumber } from "@victorequena22/utiles";
class ListaCompra extends CardBuscador {
    context: any = {};
    con = conCompra();
    placeholder = "BUSCAR COMPRA";
    buscarEn = ["codigo", "nombre", 'fecha', 'rif'];
    fecha_init = 'dd/mm/aaaa';
    fecha_fin = 'dd/mm/aaaa';
    productos: Producto[] = []
    status = -1;
    user = -1;
    Title() {
        return <>
            <h4 className='mr-auto'><i className="fa fa-search"></i> BUSCAR COMPRA</h4>
            <Link to="/compra/nueva" className="btn btn-primary"><span className="fa fa-plus"></span> NUEVA COMPRA</Link>
        </>
    }
    Avansado() {
        const { fecha_init, fecha_fin, status, user, productos, setAvanzados } = this;
        return <Avanzado setData={setAvanzados.bind(this)}
            estatus={['CANCELADO', 'SIN FACTURA', 'FACTURADA']}
            fecha_init={fecha_init} fecha_fin={fecha_fin}
            status={status} user={user} productos={productos} />
    }
    setAvanzados({ fecha_init, fecha_fin, status, user, productos }: AvanzadosProps) {
        if (fecha_init) this.fecha_init = fecha_init;
        if (fecha_fin) this.fecha_fin = fecha_fin;
        if (user) this.user = user;
        if (status) this.status = status;
        if (status === 0) this.status = status;
        if (productos) this.productos = productos;
        this.forceUpdate()
    }
    filter() {
        const { fecha_init, fecha_fin, status, user, productos } = this;
        let itens = this.ordenar();
        return itens.filter((c: GeneralFila) => {
            if (c.status !== status && status !== -1) return false;
            if (c.usuario !== user && user !== -1) return false;
            const creacion = fechaToNumber(c.fecha);
            if (fecha_fin !== 'dd/mm/aaaa' && creacion > fechaToNumber(fecha_fin)) return false;
            if (fecha_init !== 'dd/mm/aaaa' && creacion < fechaToNumber(fecha_init)) return false;
            if (!productos.every(p => c.detalles.some(d => p.codigo === d))) return false;
            return true;
        });
    }
    Header() {
        const { Th } = this;
        return <tr className="info">
            <Th label='codigo' width='100px'>N°</Th>
            <Th label='fecha' width='120px'>FECHA</Th>
            <Th label='nombe' width='calc(100% - 585px)'>PROVEEDOR</Th>
            <Th width='160px'>MONTO</Th>
            <Th width='100px'>ESTATUS</Th>
            <Th width='145px'>ACCIONES</Th>
        </tr >
    }
    Row(p: GeneralFila) {
        return <FilaCompra con={this.con} key={"cot" + p.codigo + p.status} data={p} />
    }
    getItens() { return this.context.Compras; }
    set() { this.context.actCompra(); }
    getEstado() { return this.context.estCompras; }
    Actualizar() {
        const { hora } = this.getEstado();
        return <Col md={3} className='mr-auto d-flex flex-row-reverse'>
            <CompraExcel compra={this.filter()} />
            <div style={{ fontSize: '12px', width: "200px", paddingLeft: '15px' }}>
                <strong>ACTUALIZADO:</strong> <br />
                {hora}
            </div>
        </Col>
    }
}

ListaCompra.contextType = ComprasContext;
export default ListaCompra;
